// 用户管理模块
const userIndex = () => import('../views/user/users/index.vue')
const userNew = () => import('../views/user/users/new.vue')
const userEdit = () => import('../views/user/users/edit.vue')

// 角色
const roleIndex = () => import('../views/user/roles/index.vue')
const roleAuth = () => import('../views/user/roles/auth.vue')

// 订单需求管理
const orderDemandIndex = () => import('../views/order/order_demands/index.vue')
const orderDemandNew = () => import('../views/order/order_demands/new.vue')
const orderDemandShow = () => import('../views/order/order_demands/show.vue')
const orderDemandEdit = () => import('../views/order/order_demands/edit.vue')

// 外协厂家
const factoryIndex = () => import('../views/order/factories/index.vue')
const factoryNew = () => import('../views/order/factories/new.vue')
const factoryEdit = () => import('../views/order/factories/edit.vue')

// 表单字段管理
const formParamsIndex = () => import('../views/order/form_params/index.vue')
const flowSet = () => import('../views/order/flow_set/index.vue')

// const repairOrderIndex = () => import('../views/order/repair_orders/index.vue')
// const repairOrderEditor = () => import('../views/order/repair_orders/editor.vue')
// const repairOrderShow = () => import('../views/order/repair_orders/show.vue')

// 订单管理模块
const orderDashboard = () => import('../views/order/orders/dashboard.vue')
const orderIndex = () => import('../views/order/orders/index.vue')
const orderShow = () => import('../views/order/orders/show.vue')
const orderEdit = () => import('../views/order/orders/edit.vue')
const orderFacroty = () => import('../views/order/orders/factory.vue')

// 库存模块
const stockDashboard = () => import('../views/stock/dashboard.vue')
const itemList = () => import('../views/stock/items/index.vue')
const itemInList = () => import('../views/stock/items/in/index.vue')
const itemOutList = () => import('../views/stock/items/out/index.vue')

const itemOutboundOrderList = () => import('../views/stock/items/outbound_order/index.vue')
const itemOutboundOrderShow = () => import('../views/stock/items/outbound_order/show.vue')

const drillList = () => import('../views/stock/drills/index.vue')
const drillShow = () => import('../views/stock/drills/show.vue')

const pdcList = () => import('../views/stock/pdcs/index.vue')
const pdcShow = () => import('../views/stock/pdcs/show.vue')

const pdcInList = () => import('../views/stock/pdcs/in/index.vue')

const pdcOutList = () => import('../views/stock/pdcs/out/index.vue')

const inventoryPdc = () => import('../views/stock/inventory/pdc/index.vue')
const inventoryItem = () => import('../views/stock/inventory/item/index.vue')

// const drillCost = () => import('../views/stock/statistic/drill_cost.vue')

// 仓库设置
const stockroomList = () => import('../views/stock/stockroom/index.vue')

export default [
    {
        path: '/user/dashboard',
        component: orderDashboard,
        name: 'moduleDashboard',
        meta: { name: '用户', en_name: "", module_name: "user" }
    },
    {
        path: '/users/index',
        component: userIndex,
        meta: { name: '用户', en_name: "users", module_name: "user", auth_id: 11100 }
    },
    {
        path: '/users/new',
        component: userNew,
        meta: { name: '用户', en_name: "users", module_name: "user", auth_id: 11101 }
    },
    {
        path: '/users/:id/edit',
        component: userEdit,
        meta: { name: '用户', en_name: "users", module_name: "user", auth_id: 11102 }
    },
    {
        path: '/roles',
        component: roleIndex,
        meta: { name: '角色', en_name: "roles", module_name: "user", auth_id: 12100 }
    },
    {
        path: '/roles/:id/auth',
        component: roleAuth,
        meta: { name: '角色', en_name: "roles", module_name: "user", auth_id: 12101 }
    },

    // 订单模块
    {
        path: '/order/dashboard',
        name: 'moduleDashboard',
        component: orderDashboard,
        meta: { name: '订单', en_name: "", module_name: "order", }
    },
    {
        path: '/order_demands',
        component: orderDemandIndex,
        meta: { name: '需求', en_name: "order_demands", module_name: "order", auth_id: 31100 }
    },
    {
        path: '/order_demands/new',
        component: orderDemandNew,
        meta: { name: '需求', en_name: "order_demands", module_name: "order", auth_id: 31100 }
    },
    {
        path: '/order_demands/:id',
        component: orderDemandShow,
        meta: { name: '需求', en_name: "order_demands", module_name: "order", auth_id: 31100 }
    },
    {
        path: '/order_demands/:id/edit',
        component: orderDemandEdit,
        meta: { name: '需求', en_name: "order_demands", module_name: "order", auth_id: 31100 }
    },

    {
        path: '/factories',
        component: factoryIndex,
        meta: { name: '外协厂家', en_name: "factories", module_name: "order", auth_id: 33100 }
    },
    {
        path: '/factories/new',
        component: factoryNew,
        meta: { name: '外协厂家', en_name: "factories", module_name: "order", auth_id: 33101 }
    },
    // {
    // 	path: '/factories/:id',
    // 	component: factoryShow,
    // 	meta: {name: '外协厂家', en_name: "factories", module_name: "order", auth_id: 33100}
    // },
    {
        path: '/factories/:id/edit',
        component: factoryEdit,
        meta: { name: '外协厂家', en_name: "factories", module_name: "order", auth_id: 33102 }
    },

    {
        path: '/form_params',
        component: formParamsIndex,
        meta: { name: '表单字段', en_name: "form_params", module_name: "order", auth_id: 34101 }
    },

    {
        path: '/flow_set',
        component: flowSet,
        meta: { name: '配置', en_name: "flow_set", module_name: "order", auth_id: 34102 }
    },

    {
        path: '/orders/index',
        component: orderIndex,
        meta: { name: '订单', en_name: "orders", module_name: "order", auth_id: 32100 }
    },
    {
        path: '/orders/ongoing',
        component: orderIndex,
        meta: { name: '订单', en_name: "orders_ongoing", module_name: "order", auth_id: 32100 }
    },
    {
        path: '/orders/pause',
        component: orderIndex,
        meta: { name: '订单', en_name: "orders_pause", module_name: "order", auth_id: 32100 }
    },
    {
        path: '/orders/close',
        component: orderIndex,
        meta: { name: '订单', en_name: "orders_close", module_name: "order", auth_id: 32100 }
    },
    {
        path: '/orders/archive',
        component: orderIndex,
        meta: { name: '订单', en_name: "orders_archive", module_name: "order", auth_id: 32100 }
    },
    {
        path: '/orders/:id',
        component: orderShow,
        meta: { name: '订单', en_name: "orders", module_name: "order", auth_id: 32101 }
    },
    {
        path: '/orders/ongoing/:id',
        component: orderShow,
        meta: { name: '订单', en_name: "orders_ongoing", module_name: "order", auth_id: 32101 }
    },
    {
        path: '/orders/pause/:id',
        component: orderShow,
        meta: { name: '订单', en_name: "orders_pause", module_name: "order", auth_id: 32101 }
    },
    {
        path: '/orders/close/:id',
        component: orderShow,
        meta: { name: '订单', en_name: "orders_close", module_name: "order", auth_id: 32101 }
    },
    {
        path: '/orders/archive/:id',
        component: orderShow,
        meta: { name: '订单', en_name: "orders_archive", module_name: "order", auth_id: 32101 }
    },
    {
        path: '/orders/archive/:id/edit',
        component: orderEdit,
        meta: { name: '订单', en_name: "orders_archive", module_name: "order", auth_id: 32102 }
    },
    {
        path: '/orders/:id/edit',
        component: orderEdit,
        meta: { name: '订单', en_name: "orders", module_name: "order", auth_id: 32102 }
    },
    {
        path: '/orders/:id/factory',
        component: orderFacroty,
        meta: { name: '订单外协信息', en_name: "orders", module_name: "order", auth_id: 32105 }
    },
    // {
    //     path: '/repair_orders',
    //     component: repairOrderIndex,
    //     meta: { name: '维修单', en_name: "repair_orders", module_name: "order", auth_id: 33100 }
    // },
    // {
    //     path: '/repair_orders/new',
    //     component: repairOrderEditor,
    //     meta: { name: '维修单', en_name: "repair_orders", module_name: "order", auth_id: 33100 }
    // },
    // {
    //     path: '/repair_orders/:id/edit',
    //     component: repairOrderEditor,
    //     meta: { name: '维修单', en_name: "repair_orders", module_name: "order", auth_id: 33100 }
    // },
    // {
    //     path: '/repair_orders/:id',
    //     component: repairOrderShow,
    //     meta: { name: '维修单', en_name: "repair_orders", module_name: "order", auth_id: 33100 }
    // },

    // 库存模块
    {
        path: '/stock/dashboard',
        name: 'moduleDashboard',
        component: stockDashboard,
        meta: { name: '库存', en_name: "", module_name: "stock", }
    },
    {
        path: '/stock/drills',
        component: drillList,
        meta: { name: '钻头', en_name: "stock_drill", module_name: "stock", auth_id: 51102 }
    },
    {
        path: '/stock/drills/in',
        component: drillList,
        meta: { name: '入库', en_name: "stock_drill_in", module_name: "stock", auth_id: 51102 }
    },
    {
        path: '/stock/drills/out',
        component: drillList,
        meta: { name: '出库', en_name: "stock_drill_out", module_name: "stock", auth_id: 51102 }
    },
    {
        path: '/stock/drills/:id',
        component: drillShow,
        meta: { name: '钻头', en_name: "stock_drill", module_name: "stock", auth_id: 51103 }
    },
    {
        path: '/stock/items',
        component: itemList,
        meta: { name: '材料', en_name: "stock_item", module_name: "stock", auth_id: 51301 }
    },
    {
        path: '/stock/items/in',
        component: itemInList,
        meta: { name: '材料入库', en_name: "stock_item_in", module_name: "stock", auth_id: 51301 }
    },
    {
        path: '/stock/item_outbound_orders',
        component: itemOutboundOrderList,
        meta: { name: '材料出库单', en_name: "item_outbound_order", module_name: "stock", auth_id: 51301 }
    },
    {
        path: '/stock/item_outbound_orders/:id',
        component: itemOutboundOrderShow,
        meta: { name: '材料出库单', en_name: "item_outbound_order", module_name: "stock", auth_id: 51301 }
    },
    {
        path: '/stock/items/out',
        component: itemOutList,
        meta: { name: '材料出库', en_name: "stock_item_out", module_name: "stock", auth_id: 51301 }
    },
    {
        path: '/stock/pdcs',
        component: pdcList,
        meta: { name: '复合片库存', en_name: "stock_pdc", module_name: "stock", auth_id: 51201 }
    },
    {
        path: '/stock/pdcs/:id/record',
        component: pdcShow,
        meta: { name: '复合片出入记录', en_name: "stock_pdc", module_name: "stock", auth_id: 51201 }
    },

    {
        path: '/stock/pdcs/in',
        component: pdcInList,
        meta: { name: '复合片入库', en_name: "stock_pdc_in", module_name: "stock", auth_id: 51201 }
    },

    {
        path: '/stock/pdcs/out',
        component: pdcOutList,
        meta: { name: '复合片出库', en_name: "stock_pdc_out", module_name: "stock", auth_id: 51201 }
    },
    {
        path: '/stock/inventory/pdc',
        component: inventoryPdc,
        meta: { name: '复合片盘点', en_name: "inventory_pdc", module_name: "stock", auth_id: 51202 }
    },
    {
        path: '/stock/inventory/item',
        component: inventoryItem,
        meta: { name: '材料盘点', en_name: "inventory_item", module_name: "stock", auth_id: 51302 }
    },
    // {
    //     path: '/stock/statistic/drill_cost',
    //     component: drillCost,
    //     meta: { name: '钻头成本核算', en_name: "drill_cost", module_name: "stock", auth_id: 51501 }
    // },
    {
        path: '/stock/stockrooms',
        component: stockroomList,
        meta: { name: '仓库', en_name: "stock_room", module_name: "stock", auth_id: 51401 }
    }
]